import React, {Component, ReactElement} from 'react'
import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import {
    NatGetAdminBulletinBoardThreadList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult,
    ThreadInfo,
} from './repository/NatGetAdminBulletinBoardThreadList'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea'
import {SearchResultCountDisplayProps} from '../../../styledComponents/adminPage/SearchResultCountDisplay'
import {SortOrder} from '../../../components/shared/SortOrder'
import SearchPageActionArea from '../../../styledComponents/adminPage/SearchPageActionArea'
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons'
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import SortableTableHeader, {
    SortableTableHeaderCell,
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader'
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody'
import {SortDirection} from '@mui/material/TableCell'
import {formatDateTimeForUpdateDate} from '../../../formatters/formatDate'
import {ROLE_TYPE, THREAD_CATEGORY, VALID_OR_NOT_CHECK} from '../../../CodeMaster'
import {Messages} from '../../../Messages'
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionColumNameCell,
    ConditionInputCell,
    ConditionTable,
    ConditionTableBody,
    ConditionTableRow,
} from '../../../styledComponents/adminPage/ConditionTable'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import PPSelect from '../../../components/shared/forms/PPSelect'
import {addEmptyData, isNoSelect} from '../../../componentHelper/selectHelper'
import {Location} from 'react-router-dom'

import {Link, TableCell, TableRow} from '@mui/material'
import {SelectChangeEvent} from '@mui/material/Select'

interface Props {
    bulletinBoardRepo: NatBulletinBoardRepo
    eventEmitter: EventEmitterExAdmin
    location: Location

}

interface States {
    searchCondition: SearchCondition
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    searchResult: SearchResult
    threadList: ThreadInfo[]
    isLoadCompleted: boolean
}

class NatAdminBulletinBoardThreadListPage extends Component<Props & AdminPagePropsSet, States> {

    subSortKey: SortOrder = new SortOrder('threadId', 'asc')

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.state = {
            searchCondition: {},
            searchConditionPageInfo: {
                pageNum: COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
                page: COMMON_CONSTANTS.FIRST_PAGE,
            },
            searchConditionSortInfo: [
                new SortOrder('updateDatetime', 'desc'),
            ],
            searchResult: {
                ['total']: 0,
                ['totalPage']: 0,
                ['start']: 0,
                ['end']: 0,
            },
            threadList: [],
            isLoadCompleted: false,
        }
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleSort = this.handleSort.bind(this)
        this.onChangeCategoryId = this.onChangeCategoryId.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.registerBulletinBoardThread = this.registerBulletinBoardThread.bind(this)
        this.onChangeCategoryId = this.onChangeCategoryId.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // スレッド一覧取得(管理)
            await this.searchAdminBulletinBoardThreadList(
                this.state.searchCondition, this.state.searchConditionPageInfo, this.state.searchConditionSortInfo,
            )
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }


    // 登録ボタン押下
    async registerBulletinBoardThread(): Promise<void> {
        this.props.navigate(
            '/admin/bulletinBoardThreadRegister',
        )
    }

    // スレッド一覧取得(管理)
    async searchAdminBulletinBoardThreadList(
        searchCondition?: SearchCondition,
        searchConditionPageInfo?: SearchConditionPageInfo,
        searchConditionSortInfo?: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {


            // ソートのサブキーを追加
            let addSearchConditionSubSortInfo: SortOrder[] = []
            if (searchConditionSortInfo) {
                addSearchConditionSubSortInfo = searchConditionSortInfo.concat(this.subSortKey)
            } else {
                addSearchConditionSubSortInfo = addSearchConditionSubSortInfo.concat(this.subSortKey)
            }

            const response: Nullable<NatGetAdminBulletinBoardThreadList> =
                await this.props.asyncCallFunction(
                    this.props.bulletinBoardRepo.getAdminBulletinBoardThreadList.bind(
                        this.props.bulletinBoardRepo,
                        searchCondition,
                        searchConditionPageInfo,
                        addSearchConditionSubSortInfo,
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            if (response && response.details) {
                this.setState({
                    threadList: response.details.threadInfo,
                    searchResult: response.details.searchResult,
                })
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    searchResults(): SearchResultCountDisplayProps {
        if (this.state.threadList.length === 0) {
            if (!Object.keys(this.state.searchCondition).length) {
                return {noResultMessage: Messages.IOPCC0015.toString('スレッド')}
            }
            return {noResultMessage: Messages.IOPCC0014.toString('')}
        }

        return {
            totalCount: this.state.searchResult.total,
            rowsPerPage: this.state.searchConditionPageInfo.pageNum,
            page: this.state.searchConditionPageInfo.page,
        }
    }

    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = {
            pageNum: this.state.searchConditionPageInfo.pageNum,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        await this.searchAdminBulletinBoardThreadList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo)
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.pageNum = Number(event.target.value)
        searchConditionPageInfo.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.searchAdminBulletinBoardThreadList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    async handleSort(sortKey: string): Promise<void> {
        this.beforeUserAction()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]
        await this.searchAdminBulletinBoardThreadList(
            this.state.searchCondition,
            this.state.searchConditionPageInfo,
            sortOrders,
        )
        this.setState({searchConditionSortInfo: sortOrders})
    }

    renderThreadTable(threadInfos: ThreadInfo[]): Nullable<ReactElement> {
        if (threadInfos.length === 0) {
            return null
        }
        const headers: SortableTableHeaderCell[] = [
            {id: 'title', label: 'タイトル'},
            {id: 'category', label: 'カテゴリ'},
            {id: 'replyCount', label: 'コメント数', sortable: true, direction: this.getSortDirection('replyCount')},
            {id: 'priority', label: '優先', sortable: true, direction: this.getSortDirection('priority')},
            {id: 'roomNumber', label: '部屋番号'},
            {id: 'contributor', label: '投稿者'},
            {id: 'invisible', label: '非表示'},
            {
                id: 'updateDatetime',
                label: '更新日時',
                sortable: true,
                direction: this.getSortDirection('updateDatetime'),
            },
        ]

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.searchResult.total ? this.state.searchResult.total : 0,
                    rowsPerPage:
                        this.state.searchConditionPageInfo.pageNum ? this.state.searchConditionPageInfo.pageNum : 0,
                    page: this.state.searchConditionPageInfo.page ? this.state.searchConditionPageInfo.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    noWrap
                    headers={headers}
                    onSortOrderChange={this.handleSort}
                />
                <SortablePaginationTableBody>
                    {threadInfos.map(
                        threadInfo => this.renderThreadRecord(threadInfo),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    renderThreadRecord(threadInfo: ThreadInfo): ReactElement {
        const threadUrl: string = `/admin/bulletinBoardThread/${threadInfo.threadId}`

        // 部屋番号
        let roomNumberForDisplay = '-'
        if (threadInfo.userId.slice(0, 1) === ROLE_TYPE.RESIDENT.value) {
            roomNumberForDisplay = `${threadInfo.contributorRidgeName} ${threadInfo.contributorRoomNumber}`
        }

        // 投稿者
        const contributorForDisplay: string = `${threadInfo.contributorFamilyName} ${threadInfo.contributorFirstName}`

        // カテゴリ
        let threadCategoryForDisplay: string = ''
        if (threadInfo.categoryId) {
            const threadCategory = THREAD_CATEGORY.codeToEnumConstants(threadInfo.categoryId)
            if (threadCategory) {
                threadCategoryForDisplay = threadCategory.label
            }
        }

        // 優先
        const priorityForDisplay = threadInfo.priority === VALID_OR_NOT_CHECK.NOT.value ?
            VALID_OR_NOT_CHECK.NOT.label : VALID_OR_NOT_CHECK.VALID.label

        // 非表示
        const invisibleForDisplay = threadInfo.invisible === VALID_OR_NOT_CHECK.NOT.value ?
            VALID_OR_NOT_CHECK.NOT.label : VALID_OR_NOT_CHECK.VALID.label


        return (
            <TableRow key={`thread_${threadInfo.threadId}`}>
                <TableCell align={'center'}><Link href={threadUrl}
                                                  underline="hover">{threadInfo.title}</Link></TableCell>
                <TableCell align={'center'}>{threadCategoryForDisplay}</TableCell>
                <TableCell align={'right'}>{threadInfo.replyCount}</TableCell>
                <TableCell align={'center'}>{priorityForDisplay}</TableCell>
                <TableCell align={'center'}>{roomNumberForDisplay}</TableCell>
                <TableCell align={'center'}>{contributorForDisplay}</TableCell>
                <TableCell align={'center'}>{invisibleForDisplay}</TableCell>
                <TableCell align={'center'}>{formatDateTimeForUpdateDate(threadInfo.updateDatetime)}</TableCell>
            </TableRow>
        )
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.page = newPage
        await this.searchAdminBulletinBoardThreadList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    onChangeCategoryId(event: SelectChangeEvent<unknown>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        const value = event.target.value as string
        searchCondition.categoryId = isNoSelect(value) ? undefined : value
        this.setState({searchCondition: searchCondition})
    }


    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ListSearchFormArea
                    searchResult={this.searchResults()}
                    onEnterKey={this.onClickSearchButton}
                >
                    <ConditionTable>
                        <ConditionTableBody>
                            <ConditionTableRow>
                                <ConditionCategoryCell>スレッド情報</ConditionCategoryCell>
                                <ConditionColumNameCell>カテゴリ情報</ConditionColumNameCell>
                                <ConditionInputCell>
                                    <PPSelect
                                        eventEmitter={this.props.eventEmitter}
                                        data={addEmptyData(THREAD_CATEGORY.values(), '全てのカテゴリ')}
                                        onChange={this.onChangeCategoryId}
                                        value={this.state.searchCondition.categoryId}
                                    />
                                </ConditionInputCell>
                                <ConditionButtonCell>
                                    <AdminDefaultMediumButton onClick={this.onClickSearchButton}>
                                        スレッドを検索する
                                    </AdminDefaultMediumButton>
                                </ConditionButtonCell>
                            </ConditionTableRow>
                        </ConditionTableBody>
                    </ConditionTable>
                </ListSearchFormArea>
                <SearchPageActionArea>
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_BOARD_MANAGEMENT}>
                        <AdminDefaultMediumButton onClick={this.registerBulletinBoardThread}>
                            新規
                        </AdminDefaultMediumButton>
                    </AuthorityChecker>
                </SearchPageActionArea>
                <PageMainArea>
                    {this.renderThreadTable(this.state.threadList)}
                </PageMainArea>
            </>
        )
    }

}

export default createAdminPage(NatAdminBulletinBoardThreadListPage)

